import Back from '../../../../features/back/Back'
import { safeHTML } from '../../../../../utils/safeHTML'
import MyId from '../../../../features/myId/MyId'
import React from 'react'
import { useUser } from '../../../../../redux/reducer/user'
import { useContent } from '../../../../../redux/reducer/content'
import useToNextState from '../../model/hooks/useToNextState'

export default function Head() {
  const { profile } = useUser()
  const { viewedFriend } = useContent()
  const toNextState = useToNextState()

  return (
    <div className={'share__head'}>
      {profile && <Back onClick={toNextState} />}
      <div className={'share__name'}>{safeHTML(viewedFriend?.username)}</div>
      <div className={'share__info'}>
        <div className={'share__space'} />
        <div className={'share__id'}>
          <MyId id={viewedFriend?.uid} />
        </div>
      </div>
    </div>
  )
}
